import React, {Component} from 'react';
import Immutable from 'immutable';
import {Trans} from '@lingui/macro';
import TestItem from '../TestItem';
import LoadingIcon from '../Icons/LoadingIcon';
import {extractTranslatedLabel} from '../../services/utilities';

//import cl from 'classnames';
import s from './TestsList.css';

function makeNewState(props) {
  return {
    currentTest: props.currentTest || '',
  };
}

class TestsList extends Component {
  constructor(props) {
    super(props);
    this.testContainer = React.createRef();
    this.state = makeNewState(props);
  }

  componentWillReceiveProps(props) {
    this.setState(() => makeNewState(props));
  }

  goToDetails = test => {
    const {goToDetails, isMobile, setCurrentTest} = this.props;
    const {currentTest} = this.state;

    //ON MOBILE YOU'RE NOT SURE CURRENT TEST EXISTS ALREADY
    if (isMobile && !currentTest) {
      setCurrentTest(test);
    }

    goToDetails();
  };

  selectTest = item => {
    this.props.setCurrentTest(item);
  };

  componentDidMount() {
    if (this.state.currentTest && this.props.isMobile) {
      this.deselectTest();
    }
  }

  componentDidUpdate(_, prevState) {
    if (prevState.size === 0) {
      return;
    }

    if (prevState.currentTest && !this.state.currentTest) {
      let testIndex = this.props.testsList.findIndex(
        test => test.get('id') === prevState.currentTest.get('id')
      );
      let testButtons = this.testContainer.current.querySelectorAll('button');

      if (testIndex > -1) {
        testButtons[testIndex]?.focus();
      }
    }
  }

  deselectTest = () => this.props.setCurrentTest(null);

  startTest = index => {
    alert(<Trans id="tests_list.start_text">Start Test {index}</Trans>);
    // alert(`Start Test ${index}`);
  };

  render() {
    const {currentTest} = this.state;
    const {userCampaign, testsList, completedTests, lang, isAssessor, isMobile} = this.props;

    const completed = completedTests.map(t => parseInt(t.get('id'), 10)).toSet();

    return (
      <div className={s.TestsList}>
        <h2 className={s.Title} onMouseEnter={this.deselectTest}>
          <Trans id="tests_list.title">ELENCO DELLE ATTIVITÀ</Trans>
        </h2>
        <div ref={this.testContainer} className={s.TestItems}>
          {testsList ? (
            testsList.map(item => {
              const campaignIs360 = userCampaign.get('is360');
              const autoEvaluated = userCampaign.get('self_evaluation') === 'y';
              const testIs360 = item.get('id') == 360;

              if (!campaignIs360 && testIs360) {
                return;
              }

              const name = extractTranslatedLabel(item, lang, 'name');
              const prerequisites = Immutable.Set(
                item.getIn(['jsonData', 'prerequisites'], []).map(p => parseInt(p, 10))
              );
              const hasPrerequisites = prerequisites.size > 0;
              const delta = prerequisites.subtract(completed);
              const missing = delta
                .map(d => testsList.find(t => parseInt(t.get('id'), 10) === d))
                .filter(d => d);

              return (
                <TestItem
                  key={`test_${item.get('id')}`}
                  label={name}
                  iconLabel={item.get('abbreviation') || name.substr(0, 2).toUpperCase()}
                  isActive={currentTest === item}
                  isCompleted={item.get('status') === 'complete'}
                  status={item.get('status')}
                  repeatable={item.get('repeatable')}
                  lang={lang}
                  missingPrerequisites={hasPrerequisites ? missing : null}
                  isAssessor={isAssessor}
                  selectTest={() => this.selectTest(item)}
                  deselectTest={this.deselectTest}
                  onClick={() => this.goToDetails(item)}
                  isMobile={isMobile}
                  supportsLegacyBrowsers={item.get('legacy')}
                />
              );
            })
          ) : (
            <div className={s.Loader}>
              <LoadingIcon size="2em" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TestsList;
